import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { retrySingleEncounter, WRITE_BACK_SEND_TOAST_KIND } from "@/api/writeBackManagement";

export function useRetrySingleWriteBack() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (encounterId: string) => retrySingleEncounter(encounterId),
    onSuccess: (result) => {
      toast[WRITE_BACK_SEND_TOAST_KIND[result.outcome]](result.message);
      queryClient.invalidateQueries({ queryKey: ["errored-write-backs"] });
    },
    onError: (error) => {
      toast.error(`Failed to retry: ${error.message}`);
    },
  });
}
